"use client";

import { LanguageContext } from "@/context/languageContext";
import { FeaturedComponent, TabsComponent } from "@/types/modules";
import { EatAndDrinkQuery } from "@/types/wordpressQueries";
import { useContext, useEffect } from "react";
import Introduction from "@/components/Introduction";
import Splash from "../Splash";
import Tabs from "../Tabs";
import Featured from "../Featured";
import { Restaurant } from "@/types/wordpress";
import { useLanguageUrl } from "@/context/languageURLContext";

interface RestaurantsComponentProps {
  data: EatAndDrinkQuery;
  restaurants: Restaurant[];
}

export default function RestaurantsComponent({
  data,
  restaurants,
}: RestaurantsComponentProps) {
  const { language } = useContext(LanguageContext);
  const { setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(`/${language === "en" ? "de" : "en"}/restaurants`);
  }, [language, setUrl]);

  const featured: FeaturedComponent = {
    backgroundColor: data.eatDrinkOptions.featured.backgroundColor,
    title: data.eatDrinkOptions.featured.title,
    custom: data.eatDrinkOptions.featured.custom,
  };

  let tabs: TabsComponent[] = [];

  restaurants.map((restaurant) => {
    tabs.push({
      title: restaurant.title,
      slug: restaurant.slug,
      imageAlign: restaurant.contentFieldsList.imageAlign,
      textAlign: restaurant.contentFieldsList.textAlign,
      content: restaurant.contentFieldsList.body,
      gallery: restaurant.contentFieldsList.gallery,
      button: restaurant.contentFieldsList.button,
      isRestaurant: true,
    });
  });

  return (
    <>
      {language === "en"
        ? data.eatDrinkOptions.slider &&
          data.eatDrinkOptions.slider.slider && (
            <Splash slider={data.eatDrinkOptions.slider.slider} />
          )
        : data.eatDrinkOptionsDE.slider &&
          data.eatDrinkOptionsDE.slider.slider && (
            <Splash slider={data.eatDrinkOptionsDE.slider.slider} />
          )}
      <Introduction
        title={
          language === "en"
            ? data.eatDrinkOptions.introduction.title
            : data.eatDrinkOptionsDE.introduction.title
        }
        content={
          language === "en"
            ? data.eatDrinkOptions.introduction.content
            : data.eatDrinkOptionsDE.introduction.content
        }
      />
      <Tabs tabs={tabs} />
      <Featured featured={featured} />
    </>
  );
}
